import React from 'react';
import { useTheme } from './ThemeContext';
import { SunIcon, MoonIcon } from 'lucide-react';
export function ThemeToggle() {
  const {
    isDarkMode,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="flex items-center justify-center p-2 rounded-full bg-slate-700 dark:bg-slate-600 hover:bg-slate-600 dark:hover:bg-slate-500 transition-colors" aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-366">
      {isDarkMode ? <SunIcon className="w-5 h-5 text-yellow-300" data-id="element-367" /> : <MoonIcon className="w-5 h-5 text-blue-300" data-id="element-368" />}
    </button>;
}